import api from './api';
import * as types from './mutation-types';

export default {
	getPlants_({ commit }) {
		return api
			.getPlants()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'plants',
						value: data !== null && data !== undefined ? data.body : null
					});

					commit(types.SEARCH_PARAM, {
						key: 'plantCd',
						value: data.body.length > 0 ? data.body[0].commCd : ''
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getCommCodes_({ commit, state }, { key, codeType }) {
		state.searchParams.codeType = codeType;
		return api
			.getCommCodes(state.searchParams)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: key,
						value: data !== null && data !== undefined ? data.body : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	getDicMsgManagements_({ commit, state }, { currentPage, pageUnit }) {
		const { searchParams } = state;

		return api
			.getDicMsgManagements({ searchParams, currentPage, pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'dicMsgManagements',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: data.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setDicMsgManagement_({ commit }, param) {
		return api
			.postDicMsgManagement(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'dicMsgManagement',
						value: data !== null && data !== undefined ? data.body[0] : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
